/**
 * @description value 를 항상 소문자로 작성
 */
export const REQUEST_HEADER_NAME = {
  AUTHORIZATION: 'authorization',
  PLATFORM: 'platform',
  X_IDUS_LOG_TOKEN: 'x-idus-log-token',
  APP_MODEL: 'app-model',
  APP_VERSION: 'app-version',
  COOKIE: 'cookie',
  BLUE_GREEN: 'blue-green',
  /**
   * application 내부(web, proxy) 에서 사용하는 custom header
   */
  X_IDUS_CUSTOM_ERROR_SILENCE: 'x-idus-custom-error-silence',
  /**
   * @description BaseApiService 에서 baseHeader 를 사용하지 않기 위한 설정
   */
  X_IDUS_CUSTOM_HEADER: 'x-idus-custom-header',
  ACCESS_TOKEN: 'access_token',
  UUID: 'uuid',
  PAGINATION: 'X-idus-pagination',
  COGNITO_ID: 'cognito_id',
} as const
